// extracted by mini-css-extract-plugin
export var border = "_1a-7";
export var brand = "_1a-s";
export var button = "_1a-k";
export var center = "_1a-9";
export var centered = "_1a-5";
export var closeButton = "_1a-b";
export var disabledWrapper = "_1a-l";
export var error = "_1a-o";
export var extraLarge = "_1a-4";
export var extraSmall = "_1a-1";
export var fill = "_1a-h";
export var footer = "_1a-g";
export var footerAction = "_1a-i";
export var footerButtons = "_1a-j";
export var header = "_1a-6";
export var headerWithClose = "_1a-c";
export var icon = "_1a-n";
export var info = "_1a-r";
export var inline = "_1a-8";
export var large = "_1a-3";
export var main = "_1a-d";
export var modal = "_1a-0";
export var neutral = "_1a-t";
export var noPadding = "_1a-f";
export var none = "_1a-u";
export var scrollable = "_1a-e";
export var small = "_1a-2";
export var success = "_1a-q";
export var tight = "_1a-m";
export var titleIcon = "_1a-a";
export var warn = "_1a-p";